<template>
  <v-row density="compact">
    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.consecutive_days"
        :items="ma_days"
        label="Consecutive Days Outperform"
        hint="Number of Days"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('consecutive_days', $event)"
      />
    </v-col>

    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.ma_days"
        :items="ma_days"
        label="Moving Avg Days"
        hint="Closing Price above the daily moving average specified"
        density="compact"
        variant="outlined"
        @update:model-value="updateConfig('ma_days', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  components: {},
  props: {
    rule: { type: Object, required: true }
  },
  emits: ['update:rule'],
  data() {
    return {
      ma_days: [],
      high_low: ['new high', 'new low'],
      volume_time_periods: [
        { text: '1 week', value: 7 },
        { text: '2 weeks', value: 14 },
        { text: '3 weeks', value: 21 },
        { text: '4 weeks', value: 28 },
        { text: '90 Days', value: 90 }
      ],
      days_time_periods: [
        { text: '1 week', value: 7 },
        { text: '2 weeks', value: 14 },
        { text: '3 weeks', value: 21 },
        { text: '4 weeks', value: 28 },
        { text: '50 days', value: 50 },
        { text: '90 days', value: 90 },
        { text: '6-months', value: 180 },
        { text: '1 Year', value: 365 }
      ],
      editedIndex: -1,
      editedOverbought: {
        rule_type: 'overbought',
        enabled: true,
        consecutive_days: 5,
        ma_days: 200,
        long_short: 'long'
      },
      defaultOverbought: {
        rule_type: 'overbought',
        enabled: true,
        consecutive_days: 5,
        ma_days: 200,
        long_short: 'long'
      }
    }
  },

  computed: {
    ...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.trend_signal',
      enabled: 'app.whaleTraderCriteria.signals.trend_signal.enabled',
      signalView: 'app.signalView',
      exit_time_periods: 'app.exit_time_periods'
    })
  },

  watch: {},

  mounted() {
    for (var i = 1; i < 71; i++) {
      this.ma_days.push(i)
    }
    for (i = 75; i < 301; i += 5) {
      this.ma_days.push(i)
    }
    if (!this.rule.config || !this.rule.config.rule_type || this.rule.trend != 'overbought') {
      this.$emit('update:rule', { ...this.rule, config: Object.assign({}, this.defaultOverbought) })
    }
  },

  methods: {
    updateConfig(key, value) {
      this.$emit('update:rule', { ...this.rule, config: { ...this.rule.config, [key]: value } })
    }
  }
}
</script>
